import { FC } from 'react';
import styled, { css } from 'styled-components';
import { t } from '@bechtel/gds';
import { listWidth, smallScreenListWidth } from '../list/styled';
import { Button, ButtonProps, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import { Tab, TabList } from '@bechtel/gds';
import { Box } from '@bechtel/gds';

export const WorkPackageDetailContainer = styled.div`
  position: absolute;
  left: ${listWidth};
  overflow-y: auto;
  height: 100%;
  width: calc(100% - ${listWidth});
  background-color: white;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
    width: calc(100% - ${smallScreenListWidth});
  }
`;

export const WorkPackageDetailStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: 100%;
  min-width: 880px;
`;

export const WorkPackageOwnersStyled = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    right: ${theme.spacings[600]};
    z-index: 1;
  `}
`;
export const WorkPackageProgressRowStyled = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[500]};
    margin-bottom: ${theme.spacings[400]};
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[600]};
  `}
`;
export const WorkPackageStatsRowStyled = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[400]};
    border: 1px solid ${theme.colors.grey[300]};
    border-radius: ${theme.radii[200]};
    padding-top: ${theme.spacings[500]};
  `}
`;
export const WorkPackageRowStyled = styled.div`
  margin-top: ${t('spacings.400')};
  margin-bottom: ${t('spacings.400')};
`;

export const AddForemanStyled = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${t('spacings.400')};
  border-top: 1px solid ${t('colors.neutral.400')};
`;

export const InformationContainerStyled = styled.div`
  padding-bottom: ${({ theme }) => theme.spacings[500]};
  padding-top: ${({ theme }) => theme.spacings[500]};
  z-index: 0;
`;

export const LoaderStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  flexGrow: { sm: 1 },
  p: { sm: '600' },
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  margin-left: ${listWidth};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    margin-left: ${smallScreenListWidth};
  }
`;

//Tabs
export const CommodityTabList = styled(TabList)`
  border-top: 1px solid ${({ theme }) => theme.colors.grey['300']};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
`;
export const TabStyled = styled(Tab)`
  flex-grow: 1;

  &:focus {
    outline: 0;
  }
`;

export const CommodityTypeListStyled = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.grey['300']};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey['300']};
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const NoCommoditiesFoundStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  width: 100%;
  height: 100%;
  text-align: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    gap: ${theme.spacings['700']};
  `};
`;
